import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { required } from '../../../../antd/form/FormValidation';

const PhdThesisReplaceModal = ({
  open,
  source,
  replacementOptions,
  schoolYearOptions,
  isLoadingCandidates,
  isSubmitting,
  onCancel,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        replacement_thesis_id: null,
        effective_school_year_id: source?.phd_school_year_id ?? null,
      });
      return;
    }

    form.resetFields();
  }, [form, open, source?.phd_school_year_id]);

  return (
    <Modal
      open={open}
      title={t('Nahradiť priradenú dizertačnú tému')}
      okText={t('Nahradiť tému')}
      cancelText={t('Zrušiť')}
      onCancel={onCancel}
      onOk={() => form.submit()}
      confirmLoading={isSubmitting}
      maskClosable={false}
    >
      <p>
        {t(
          'Pôvodná téma sa archivuje a vybraná schválená voľná téma sa priradí rovnakému doktorandovi.',
        )}
      </p>
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          label={t('Náhradná dizertačná téma')}
          name="replacement_thesis_id"
          rules={[required(t)]}
        >
          <Select
            showSearch
            optionFilterProp="label"
            placeholder={t('Vyberte náhradnú tému')}
            options={replacementOptions}
            loading={isLoadingCandidates}
            notFoundContent={t('Nie je dostupná vhodná náhradná téma')}
          />
        </Form.Item>
        <Form.Item
          label={t('Školský rok účinnosti')}
          name="effective_school_year_id"
          rules={[required(t)]}
        >
          <Select
            showSearch
            optionFilterProp="label"
            placeholder={t('Vyberte školský rok')}
            options={schoolYearOptions}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

PhdThesisReplaceModal.propTypes = {
  open: PropTypes.bool.isRequired,
  source: PropTypes.object,
  replacementOptions: PropTypes.array.isRequired,
  schoolYearOptions: PropTypes.array.isRequired,
  isLoadingCandidates: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default PhdThesisReplaceModal;
